import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import BaseApiInstance from './base';

const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
const UNKNOWN_STATUS = 0;

const getUnknownErrorMessage = error => {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  return 'Something went wrong';
};

const getErrorData = (data, code, message) => {
  if (data && typeof data === 'object') {
    return {
      code,
      message,
      ...data,
    };
  }

  return { code, message };
};

const axiosBaseQuery =
  () =>
  async ({ url, method = 'get', data, params }) => {
    try {
      const response = await BaseApiInstance({ url, method, data, params });
      return { data: response.data };
    } catch (error) {
      if (!axios.isAxiosError(error)) {
        const message = getUnknownErrorMessage(error);
        return {
          error: {
            status: UNKNOWN_STATUS,
            code: UNKNOWN_ERROR,
            message,
            data: getErrorData(undefined, UNKNOWN_ERROR, message),
          },
        };
      }

      const status = error.response?.status ?? UNKNOWN_STATUS;
      const code = error.code ?? UNKNOWN_ERROR;
      const { message } = error;

      return {
        error: {
          status,
          code,
          message,
          data: getErrorData(error.response?.data, code, message),
        },
      };
    }
  };

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['BikeProductTitles', 'FftriLabels'],
  endpoints: () => ({}),
});
